import "../CSS/itemEvento.css";
import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Link } from "react-router-dom";
import React, { useRef, useEffect, useState, Fragment } from "react";
import Button from "@mui/material/Button";
import LocalActivityIcon from '@mui/icons-material/LocalActivity';

function ItemEvento(props) {
  const [isPaulet, setIsPaulet] = useState(true);
  const [fecha, setFecha] = useState(
    new Date(props.fecha.toString()).getDate() +
      " de " +
      getMonthName(new Date(props.fecha.toString()).getMonth() + 1) 
      
  );
  const [hora, setHora] = useState(
	props.fecha.toString().split(" ")[1]
      
  );
  const [hola, setHola] = useState("Hola");
  function getMonthName(monthNumber) {
    if (monthNumber) {
      //console.log("la fecha es " + props.nombre )
      //console.log("El mes es " + monthNumber )
      const date = new Date();
      date.setMonth(monthNumber - 1);

      const formatter = new Intl.DateTimeFormat("es-pe", { month: "long" });

      return formatter.format(date);
    }
  }
  useEffect(() => {
   // console.log("Tipo de evento: " + props.salon);
    if (props.salon == "Salon de eventos") {
      setIsPaulet(false);
    } else {
      setIsPaulet(true);
    }
  }, []);
  return (
    <div className="evento-card">
      <div>
        <img
          id="imagenTienda"
          className="evento-logoEmpresa"
          src={props.imagen}
          alt="flecha"
        />
      </div>
      <div className="itemBody">
        <div className="evento-cabecera">
          <p>{props.nombre}</p>
          <p>Fecha: {fecha}</p>
		  <p>Hora : {hora}</p>
          <p>{props.descripcion}</p>
        </div>
        <div className="evento-detalles">
          {isPaulet ? (
            <Link to={`/eventos/${props.id}/registrarParticipante`}>
              <Button
                variant="contained"
                color="success"
                endIcon={<LocalActivityIcon />}
              >
                RESERVAR
              </Button>
            </Link>
          ) : (
            <Link to={`/eventos/${props.id}/registrarParticipanteSalon`}>
              <Button
                variant="contained"
                color="success"
                endIcon={<LocalActivityIcon />}
              >
                RESERVAR
              </Button>
            </Link>
          )}
        
        </div>
      </div>

      <Link to={`/panelAdmin/eventos/${props.id}`}>
        <img
          className="evento-icons evento-editar"
          src={require(`../img/editar.png`)}
        />
      </Link>

      <img
        className="evento-icons evento-borrar"
        src={require(`../img/borrar.png`)}
        alt=""
        onClick={() => props.deleteEvento(props.id)}
      />
    </div>
  );
}

export default ItemEvento;
